import { useState } from 'react';

interface FAQItem {
  id: string;
  question: string;
  answer: string;
  category: string;
}

const FAQ_ITEMS: FAQItem[] = [
  {
    id: 'faq-1',
    category: '서비스',
    question: '데스티니GPT란 어떤 서비스인가요?',
    answer: '데스티니GPT는 동양의 사주팔자(四柱八字)와 서양 점성술, 그리고 주역(周易)을 통합하여 AI로 분석하는 운명 리포트 서비스입니다. 생년월일과 출생 시간을 입력하면 탄생 차트와 평생 운세 리포트를 즉시 받아볼 수 있습니다. 단순한 오늘의 운세부터 평생 대운 흐름까지 체계적으로 분석해드립니다.',
  },
  {
    id: 'faq-2',
    category: '가격',
    question: 'Basic, Premium, VIP 플랜은 어떻게 다른가요?',
    answer: 'Basic($9.99)은 오늘의 운세와 기본 성향 분석, 오행 요약을 제공합니다. Premium($29.99)은 사주팔자 완전 분석, 서양 점성술 통합, 주역 해석, 대운 및 2026 월별 운세까지 포함한 종합 인생 리포트입니다. VIP($99)는 세 가지 복합 엔진 분석에 더해 AI 1:1 심층 채팅 무제한 상담이 포함된 최상위 서비스입니다.',
  },
  {
    id: 'faq-3',
    category: '분석',
    question: '사주팔자와 점성술은 어떻게 통합 분석되나요?',
    answer: '데스티니GPT는 동양의 사주팔자(생년월일시 기반 천간지지 분석)와 서양 점성술(행성 위치 및 별자리 배치)을 AI 알고리즘으로 교차 분석합니다. 두 시스템에서 공통으로 나타나는 운세 패턴을 강조하고, 서로 보완하는 정보를 결합하여 훨씬 정확하고 입체적인 운명 리포트를 제공합니다.',
  },
  {
    id: 'faq-4',
    category: '결제',
    question: '결제 후 리포트는 어떻게 받나요?',
    answer: '결제 완료 후 즉시 리포트 페이지로 이동하며, 등록하신 이메일 주소로 PDF 형태의 리포트도 함께 발송됩니다. 이메일로 전송된 PDF는 언제든 다시 열람하거나 인쇄하실 수 있으며, 별도 앱 설치 없이 웹 브라우저로 즉시 확인 가능합니다.',
  },
  {
    id: 'faq-5',
    category: '분석',
    question: '출생 시간을 모르면 어떻게 하나요?',
    answer: '출생 시간을 모르시는 경우, 정오(12:00)나 일반적으로 추정되는 시간대를 입력하셔도 됩니다. 다만 출생 시간은 시주(時柱)를 결정하는 매우 중요한 요소이므로, 가능하다면 병원 출생 기록이나 부모님께 확인하시는 것을 추천드립니다. 시간이 정확할수록 분석의 정밀도가 높아집니다.',
  },
  {
    id: 'faq-6',
    category: '서비스',
    question: 'VIP AI 상담은 어떻게 진행되나요?',
    answer: 'VIP 플랜 결제 완료 후 리포트 페이지 하단의 AI 1:1 상담 섹션에서 바로 이용하실 수 있습니다. 당신의 사주팔자 데이터를 학습한 전담 AI가 재물, 연애, 직업, 건강, 인간관계 등 모든 분야에 걸쳐 맞춤형 심층 답변을 드립니다. 메시지 횟수 제한 없이 무제한으로 이용 가능합니다.',
  },
  {
    id: 'faq-7',
    category: '가격',
    question: '런칭 기념 할인은 언제까지 적용되나요?',
    answer: 'Premium 플랜의 런칭 기념 특가($29.99, 정가 $59)는 한정 기간에만 제공됩니다. 결제 페이지의 카운트다운 타이머가 0이 되면 정가로 복귀합니다. 지금 바로 결제하시면 49% 할인된 가격에 평생 운세 리포트를 받아보실 수 있습니다.',
  },
  {
    id: 'faq-8',
    category: '결제',
    question: '개인정보와 결제 정보는 안전하게 보호되나요?',
    answer: '네, 데스티니GPT는 SSL 256-bit 암호화로 모든 데이터를 보호합니다. 결제는 PayPal, Stripe, Wise 등 검증된 글로벌 결제 시스템을 통해 이루어지며, 카드 정보는 당사 서버에 저장되지 않습니다. 입력하신 생년월일 등 개인정보는 운세 분석 목적으로만 사용되며 제3자에게 공유되지 않습니다.',
  },
];

const CATEGORIES = ['전체', '서비스', '분석', '가격', '결제'];

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);
  const [activeCategory, setActiveCategory] = useState('전체');

  const filtered = activeCategory === '전체'
    ? FAQ_ITEMS
    : FAQ_ITEMS.filter((f) => f.category === activeCategory);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="py-20 px-4 relative overflow-hidden" id="faq">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#070414]/80 via-[#0a0618] to-[#070414]/80" />

      <div className="relative z-10 max-w-3xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-4"
            style={{ background: 'rgba(139,92,246,0.1)', border: '1px solid rgba(139,92,246,0.3)' }}
          >
            <i className="ri-question-answer-fill text-purple-400 text-sm"></i>
            <span className="text-xs font-bold text-purple-400 tracking-widest uppercase">FAQ</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-3" style={{ fontFamily: '"Cinzel", serif' }}>
            자주 묻는 질문
          </h2>
          <p className="text-sm text-purple-300/70 max-w-lg mx-auto leading-relaxed">
            데스티니GPT 서비스에 대해 궁금하신 점을 모았습니다.
            더 궁금한 점이 있으시면 AI 상담을 이용해 주세요.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-1.5 rounded-full text-xs font-semibold transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat ? 'text-white' : 'text-purple-400/60 hover:text-purple-300'
              }`}
              style={{
                background: activeCategory === cat
                  ? 'linear-gradient(135deg, rgba(139,92,246,0.4), rgba(109,40,217,0.3))'
                  : 'rgba(255,255,255,0.04)',
                border: activeCategory === cat
                  ? '1px solid rgba(139,92,246,0.5)'
                  : '1px solid rgba(255,255,255,0.1)',
              }}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* FAQ Items */}
        <div className="space-y-3 mb-10">
          {filtered.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="rounded-2xl overflow-hidden transition-all duration-300"
                style={{
                  background: isOpen
                    ? 'linear-gradient(135deg, rgba(139,92,246,0.1), rgba(109,40,217,0.06))'
                    : 'rgba(255,255,255,0.03)',
                  border: isOpen
                    ? '1px solid rgba(139,92,246,0.35)'
                    : '1px solid rgba(255,255,255,0.08)',
                }}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
              >
                <button
                  onClick={() => toggle(item.id)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-4 text-left cursor-pointer group"
                >
                  <div className="flex items-center gap-3 flex-1 min-w-0">
                    <span className="text-[10px] font-bold px-2 py-0.5 rounded-full flex-shrink-0"
                      style={{
                        background: 'rgba(139,92,246,0.15)',
                        border: '1px solid rgba(139,92,246,0.3)',
                        color: '#a78bfa',
                      }}
                    >
                      {item.category}
                    </span>
                    <h4 className={`text-sm font-semibold leading-relaxed transition-colors ${isOpen ? 'text-white' : 'text-white/80 group-hover:text-white'}`}
                      itemProp="name"
                    >
                      {item.question}
                    </h4>
                  </div>
                  <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                    isOpen ? 'rotate-180' : ''
                  }`}
                    style={{
                      background: isOpen ? 'rgba(139,92,246,0.25)' : 'rgba(255,255,255,0.06)',
                      border: `1px solid ${isOpen ? 'rgba(139,92,246,0.4)' : 'rgba(255,255,255,0.1)'}`,
                    }}
                  >
                    <i className={`ri-arrow-down-s-line text-sm ${isOpen ? 'text-purple-400' : 'text-white/40'}`}></i>
                  </div>
                </button>

                {/* Answer */}
                <div
                  className="overflow-hidden transition-all duration-300"
                  style={{ maxHeight: isOpen ? '400px' : '0' }}
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <div className="px-6 pb-5 pt-0">
                    <div className="h-px mb-3" style={{ background: 'rgba(139,92,246,0.15)' }} />
                    <p className="text-sm text-purple-200/75 leading-relaxed" itemProp="text">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-3 px-6 py-4 rounded-2xl"
            style={{ background: 'rgba(251,191,36,0.06)', border: '1px solid rgba(251,191,36,0.2)' }}
          >
            <div className="flex items-center gap-2">
              <i className="ri-customer-service-2-fill text-amber-400 text-base"></i>
              <span className="text-sm text-white/80 font-medium">더 궁금한 점이 있으신가요?</span>
            </div>
            <a
              href="/#hero"
              onClick={(e) => { e.preventDefault(); document.getElementById('hero')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="px-5 py-2 rounded-xl bg-gradient-to-r from-amber-400 to-yellow-500 text-black font-bold text-xs hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
            >
              AI 상담 시작하기
            </a>
          </div>
        </div>
      </div>

      {/* Schema.org FAQPage structured data */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: FAQ_ITEMS.map((item) => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: item.answer,
            },
          })),
        }),
      }} />
    </section>
  );
}
